import axios from "axios";  

import { createUserAPI, deleteUserAPI, getUsersAPI, updateUserAPI, } from "../services/userAPI";

import { exportDataAPI ,searchDataAPI } from "../services/dataAPI";

// const API_BASE_URL = "http://localhost:8000/api";
const API_BASE_URL = "https://api.reacxle.com/api";


const useAPI = () => {

  const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add request interceptor for authentication
  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for handling auth errors
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('token');
        // Don't redirect to login since this is opened from mobile app
        window.location.href = `/subscription?error=${encodeURIComponent('Authentication failed')}`;
      }
      return Promise.reject(error);
    }
  );



  return {
    auth: {
    
    },
    
    user: {
      get: (data?: any) => getUsersAPI(api),
      create: (formData: FormData) => createUserAPI(api, formData),
      update: (data?: any) => updateUserAPI(api, data),
      delete: (id: string) => deleteUserAPI(api, id)
    },
    data: {
      getAll: (fromDate?: string, toDate?: string, filterName?: string, quickSearchTerm?: string) => 
        searchDataAPI(api, filterName, fromDate, toDate, quickSearchTerm),
      export: (fromDate?: string, toDate?: string) => exportDataAPI(api, fromDate, toDate)
    }
  };
};

export default useAPI;
